export default "__VITE_ASSET__BUDm0Dfy__"